export default __webpack_public_path__ + "static/media/GasMask.256.51cb6b2e.png";